import { IDialogHandleState } from "../reducers/dialog"

export const SET_NEW_STAGE = "SET_NEW_STAGE"

export function setNewStage(key: string, dialogState: Partial<IDialogHandleState<any>>, path: string, prevKey: string | null) {
    return {
        type: SET_NEW_STAGE,
        payload: { key, ...dialogState, path, prevKey }
    }
}

export const RESET_DIALOG_STATE = "RESET_DIALOG_STATE";

export function resetDialogStages() {
    return {
        type: RESET_DIALOG_STATE
    }
}